/*
 * Body Class Toggle library
 *
 **/

import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

custom.bodyclassToggle = (() => {
  const triggerOpenClass = 'js-bodyclass-toggle-open';
  const triggerCloseClass = 'js-bodyclass-toggle-close';

  const $openTriggers = $('.' + triggerOpenClass);
  const $closeTriggers = $('.' + triggerCloseClass);

  function getClassName(triggerEl) {
    const $trigger = $(triggerEl);
    return $trigger.data('toggle-class');
  }

  function addClassHandler(event) {
    const className = getClassName(event.currentTarget);
    $('body').addClass(className);
    const filterType =
      event.target.parentElement.parentElement.dataset.filterCategory;
    const removeBodyScrollElement = filterType
      ? `.ais-facets--${filterType}`
      : '.ais-facets';
    if (className.includes('js-search-filter-open'))
      disableBodyScroll(document.querySelector(removeBodyScrollElement)); // Lock body Element only for filter selected
  }

  function removeClassHandler(event) {
    const className = getClassName(event.currentTarget);
    $('body').removeClass(className);
    if (className.includes('js-search-filter-open')) clearAllBodyScrollLocks(); // Release Locked body Element
  }

  function init() {
    if ($openTriggers.length > 0) {
      $.each($openTriggers, (index, trigger) => {
        $(trigger).on('click', addClassHandler);
      });
    }
    if ($closeTriggers.length > 0) {
      $.each($closeTriggers, (index, trigger) => {
        $(trigger).on('click', removeClassHandler);
      });
    }
  }

  return {
    init: init,
  };
})();

custom.bodyclassToggle.init();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/bodyclass-toggle.js